"use client";

import React from "react";
import AppHero from "src/components/Common/AppHero";
import TechStats from "src/components/Common/TechStats";
import { caseStudies } from "src/utils/mock/caseStudies";
import FAQSection from "src/components/Common/FAQSection";
import WhyChooseUs from "src/components/Common/WhyChooseUs";
import TechsSection from "src/components/Common/TechsSection";
import ProcessStepsSection from "src/components/Common/ProcessStepsSection";
import PagesServicesSection from "src/components/Common/PagesServicesSection";
import CommonContactSection from "src/components/Common/CommonContactSection";
import { IonicAppHeroData, ionicStatsData, ionicSolutionsAndProcessData, ionicTechnologiesData, ionicAboutData, ionicFaqs } from "src/utils/mock/ionicAppData";

export default function IonicAppDevelopment({ caseStudies: apiCaseStudies }) {
  const finalCaseStudies = apiCaseStudies || caseStudies;
  const liveProjects = finalCaseStudies?.projects?.liveProjects || [];

  const ionicProjects = liveProjects.filter((project) => {
    const isActive = project.projectStatus === "active";
    const mobileApp = project.platforms?.toLowerCase().includes("mobile");

    // const hasIonicTech = project.technologies?.some((tech) => tech.name?.toLowerCase().includes("mobile"));

    return isActive && mobileApp;
  });

  const filteredData = {
    ...finalCaseStudies,
    projects: {
      ...finalCaseStudies?.projects,
      liveProjects: ionicProjects,
    },
  };
  const techIcons = filteredData?.projects?.liveProjects[0]?.technologies;
  return (
    <div>
      <AppHero heroData={IonicAppHeroData} />
      <TechStats stats={ionicStatsData} />

      <WhyChooseUs data={ionicSolutionsAndProcessData} />

      <section className="w-full bg-background-primary text-white px-6! md:px-12! relative overflow-hidden font-sans">
        <div className="absolute top-1/4 right-0 w-[500px] h-[500px] bg-purple-900/10 blur-[150px] -z-10 rounded-full" />
        <div className="absolute bottom-1/4 left-0 w-[500px] h-[500px] bg-blue-950/20 blur-[150px] -z-10 rounded-full" />

        <div className="max-w-8xl mx-auto!">
          <PagesServicesSection data={filteredData} />
          <ProcessStepsSection data={ionicTechnologiesData} techIcons={techIcons} />
          <TechsSection sections={ionicAboutData} mainTitle="About Ionic App Development" />
        </div>
      </section>

      <FAQSection faqs={ionicFaqs} />

      <CommonContactSection />
    </div>
  );
}
